/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Signintitle2Inputs */

const zh_learn_signintitle2 = /** @type {(inputs: Learn_Signintitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后继续`)
};

const en_learn_signintitle2 = /** @type {(inputs: Learn_Signintitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to continue`)
};

const es_learn_signintitle2 = /** @type {(inputs: Learn_Signintitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para continuar`)
};

/**
* | output |
* | --- |
* | "Sign in to continue" |
*
* @param {Learn_Signintitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_signintitle2 = /** @type {((inputs?: Learn_Signintitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Signintitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_signintitle2(inputs)
	if (locale === "en") return en_learn_signintitle2(inputs)
	return es_learn_signintitle2(inputs)
});
export { learn_signintitle2 as "learn_signInTitle" }